import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs';
import { 
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Observable<boolean> | boolean { 
    // return this.verificarAcesso(); 

    if (!!this.authService.isLoggedIn()) {
      return true;
    }

    // Redireciona para o login e passa a URL pretendida no queryParams
    this.router.navigate(['/login'], { 
      queryParams: { returnUrl: state.url } 
    });

    return false;

  }

  /*
  private verificarAcesso() {
    if (!!this.authService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
  */

}
